import React from 'react';
import { View } from 'react-native';
import IconButton from '../../v2BaseComponents/IconButton';
import Stack from '../../v2BaseComponents/Stack';
import TimeDisplay from './TimeDisplay';

export type AudioPlayerControlsOwnProps = {
    isPlaying: boolean;
    onPlay: () => void;
    onPause: () => void;
    duration: number | null;
    position: number;
};

export type AudioPlayerControlsProps = AudioPlayerControlsOwnProps;

const TIME_DISPLAY_WIDTH = 40;

const AudioPlayerControls: React.FC<AudioPlayerControlsProps> = (props) => {
    return (
        <View style={{ width: '100%', paddingLeft: 16, paddingRight: 16 }}>
            <Stack horizontal fullWidth justify="space-between" align="flex-start">
                <Stack horizontal justify="flex-start" style={{ width: TIME_DISPLAY_WIDTH }}>
                    {props.duration ? <TimeDisplay position={props.position} duration={props.duration} /> : null}
                </Stack>
                <IconButton
                    variant="audio-play-pause-button"
                    icon={props.isPlaying ? 'Pause' : 'Play'}
                    onPress={() => {
                        if (props.isPlaying) {
                            props.onPause();
                        } else {
                            props.onPlay();
                        }
                    }}
                />
                <Stack horizontal justify="flex-end" style={{ width: TIME_DISPLAY_WIDTH }}>
                    {props.duration ? (
                        <TimeDisplay position={props.position} duration={props.duration} isRemaining />
                    ) : null}
                </Stack>
            </Stack>
        </View>
    );
};

export default React.memo(AudioPlayerControls);
